// components/screens/PaymentErrorScreen.tsx
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import React from 'react';
import { useTranslation } from 'react-i18next';

import PaymentResultPage from '../Components/PaymentResult/PaymentResultPage';
import { RootStackParamList } from '../navigator';

interface Props {
	navigation: NativeStackNavigationProp<RootStackParamList, 'PaymentError'>;
}

export default function PaymentErrorScreen({ navigation }: Props) {
	const { t } = useTranslation();

	return (
		<PaymentResultPage
			status='error'
			title={t('T_PAYMENT_FAILED', { defaultValue: 'Payment Failed' })}
			message={t('T_SITE_PAYMENT_FAILED_MESSAGE', {
				defaultValue: 'Your payment could not be processed.',
			})}
			action={{
				label: t('T_SITE_PAYMENT_RETURN_TO_PROFILE', { defaultValue: 'Return to Profile' }),
				onPress: () => navigation.replace('Profile'),
				testId: 'cta-payment-error-return-profile',
			}}
		/>
	);
}
